/**
 * Phiếu thu
 * pvdat1 07/06/2024
 */
export default {
  Title: 'Phiếu thu',
  PeopleSubmit: 'Người nộp',
  FullName: 'Họ và tên',
  Indentify: 'Số CCCD',
  IndentifyTooltip: 'Số chưng minh nhân dân',
  Address: 'Địa chỉ',
  Detail: {
    Description: 'Diễn giải',
    DocumentInclude: 'Kèm theo',
    PostedDate: 'Ngày HT',
    PostedDateTitle: 'Ngày hạch toán',
    RefDate: 'Ngày CT',
    RefDateTitle: 'Ngày chứng từ',
    RefNo: 'Số CT',
    RefNoTitle: 'Số chứng từ',
    DetailListNo: 'Số bảng kê',
    VoucherReferent: 'CT tham chiếu',
  },
};
